module.exports = __webpack_public_path__ + "img/11.bba6f785.png";